import { Heading, Text } from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import cx from 'classnames'

import TitleWithLogo from '../title-with-logo/title-with-logo'
import { PurpleCircle } from './assets'
import styles from './vertical-steps-section.module.css'

export interface VerticalStepsSectionProps {
  headingLeftText?: string
  headingRightText?: string
  headingLogo?: 'cinchShield' | 'cinchCharge' | 'cinchChargePurple'
  body: string
  steps: { heading: string; body: string }[]
}

const VerticalStepsSection: React.FC<VerticalStepsSectionProps> = ({
  headingLeftText,
  headingRightText,
  headingLogo,
  body,
  steps,
}) => {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024

  return (
    <div className={styles.container}>
      <div className={styles.titleBodyWrapper}>
        <div className={styles.titleWrapper}>
          <TitleWithLogo
            headingLevel="h3"
            leftText={headingLeftText}
            rightText={headingRightText}
            textClassName={styles.title}
            logo={headingLogo}
            logoHeight={isMobile ? '30' : '36'}
            logoWidth={isMobile ? '142' : '182'}
          />
        </div>

        <Text className={styles.body}>{body}</Text>
      </div>

      <div className={styles.stepsSection}>
        {steps.map((step, index) => (
          <div key={`Step ${index}: ${step.heading}`}>
            <div className={styles.stepHeaderWrapper}>
              <PurpleCircle />
              <Heading element="h4" className={styles.stepTitle}>
                {step.heading}
              </Heading>
            </div>
            <div
              className={cx(styles.stepBodyWrapper, {
                [styles.borderLeft]: index !== steps.length - 1,
              })}
            >
              <Text
                className={cx(styles.stepBody, {
                  [styles.lastStepBody]: index === steps.length - 1,
                })}
              >
                {step.body}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VerticalStepsSection
